const Flickity = require('flickity');
const Masonry = require('masonry-layout');
import GLightbox from "glightbox";

export default () => {

    const carousels = document.querySelectorAll('[data-gallery-carousel]');
    if (carousels.length) {
        for (const carousel of carousels) {

            const dom = carousel.querySelector('[data-slider]');
            const next = carousel.querySelector('[data-next]');
            const prev = carousel.querySelector('[data-prev]');
            const zoom = carousel.querySelector('[data-zoom]');

            const id = carousel.getAttribute('data-gallery-carousel');

            const f = new Flickity(dom, {
                cellAlign: 'left',
                imagesLoaded: true,
                wrapAround: true,
                freeScroll: true,
                freeScrollFriction: 0.03,
                pageDots: false,
                prevNextButtons: false // slider.children.length > 10
            });

            next.addEventListener('click', (e) => {
                e.preventDefault();
                f.next();
            });

            prev.addEventListener('click', (e) => {
                e.preventDefault();
                f.previous();
            });

            const gLightbox = GLightbox({
                selector: '[data-element="' + id +'"]'
            });

            zoom.addEventListener('click', (e) => {
                e.preventDefault();
                gLightbox.open();
            })

        }
    }

    const masonryGrids = document.querySelectorAll('[data-gallery-grid]');
    if (masonryGrids.length) {
        for (const grid of masonryGrids) {
            const masonry = new Masonry( grid, {
                itemSelector: '.img-item'
            });
        }
    }


    const images = document.querySelectorAll('[data-gallery-popup]');
    if (images.length) {
        GLightbox({
            selector: '[data-gallery-popup]',
        });
    }
}
